const LEAD_FORENSICS_USER = '818003';
const LEAD_FORENSICS_CAPTURE_ENDPOINT = 'https://secure.leadforensics.com/Track/Capture.aspx';
const LEADERSHIP_PAGE_PATH_SEGMENT = '/about-us/our-leadership-team';
const LEAD_FORENSICS_CONSENT_GROUP = 'C0002';
const EXECUTIVE_GROUP_LABEL = 'Executive Leadership Team';
const BOARD_GROUP_LABEL = 'Board of Directors';
const LEADERSHIP_GROUP_KEYS = {
    executive: 'executive-leadership-team',
    board: 'board-of-directors',
};
const slugify = (value) => value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
const normalizeGroupName = (groupName) => groupName.toLowerCase().replace(/\s+/g, ' ').trim();
const resolveLeadershipGroupKey = (groupName) => {
    const normalized = normalizeGroupName(groupName);
    if (normalized === normalizeGroupName(EXECUTIVE_GROUP_LABEL)) {
        return LEADERSHIP_GROUP_KEYS.executive;
    }
    if (normalized === normalizeGroupName(BOARD_GROUP_LABEL)) {
        return LEADERSHIP_GROUP_KEYS.board;
    }
    return null;
};
const getGroupLabel = (groupKey) => {
    if (groupKey === LEADERSHIP_GROUP_KEYS.executive) {
        return EXECUTIVE_GROUP_LABEL;
    }
    return BOARD_GROUP_LABEL;
};
const getProfileIdentifier = (personName, stableIdentifier) => {
    const identifier = (stableIdentifier === null || stableIdentifier === void 0 ? void 0 : stableIdentifier.trim()) || '';
    if (identifier) {
        return slugify(identifier);
    }
    return slugify(personName);
};
const hasLeadForensicsConsent = () => typeof window.OnetrustActiveGroups === 'string' &&
    window.OnetrustActiveGroups.includes(LEAD_FORENSICS_CONSENT_GROUP);
const isLeadershipPage = () => window.location.pathname.toLowerCase().includes(LEADERSHIP_PAGE_PATH_SEGMENT);
const createFallbackGuid = () => {
    const timestamp = Date.now().toString(36);
    const randomPart = Math.random().toString(36).slice(2, 12);
    return `${timestamp}-${randomPart}`;
};
const createTrackingGuid = () => {
    if (typeof crypto !== 'undefined' &&
        typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }
    return createFallbackGuid();
};
const encodeForLeadForensics = (value, maxLength) => encodeURIComponent(value).substring(0, maxLength);
const createTrackLoadImplementation = () => (docloc, doctit) => {
    const trackScreenWidth = encodeForLeadForensics(String(window.screen.width), 6);
    const trackScreenHeight = encodeForLeadForensics(String(window.screen.height), 6);
    const trackReferrer = encodeForLeadForensics(document.referrer, 1100);
    const trackTitle = encodeForLeadForensics(doctit, 200);
    const trackLocation = encodeForLeadForensics(docloc, 200);
    const trackAppName = encodeForLeadForensics(window.navigator.appName, 100);
    const trackAgentVersion = encodeForLeadForensics(`${window.navigator.userAgent}.lfcd${window.screen.colorDepth}.lflng`, 1000);
    const trackDomain = encodeForLeadForensics(document.domain, 200);
    const trackGuid = createTrackingGuid();
    const trackLink = `${LEAD_FORENSICS_CAPTURE_ENDPOINT}` +
        `?trk_user=${LEAD_FORENSICS_USER}` +
        `&trk_sw=${trackScreenWidth}` +
        `&trk_sh=${trackScreenHeight}` +
        `&trk_ref=${trackReferrer}` +
        `&trk_tit=${trackTitle}` +
        `&trk_loc=${trackLocation}` +
        `&trk_agn=${trackAppName}` +
        `&trk_agv=${trackAgentVersion}` +
        `&trk_dom=${trackDomain}` +
        `&trk_guid=${trackGuid}` +
        '&trk_cookie=NA';
    const preload = new Image();
    preload.src = trackLink;
};
const getTrackLoad = () => {
    if (typeof window.track_load === 'function') {
        return window.track_load;
    }
    const generatedTrackLoad = createTrackLoadImplementation();
    window.track_load = generatedTrackLoad;
    return generatedTrackLoad;
};
const buildLeadershipPseudoPageUrl = (groupKey, identifier) => {
    const encodedIdentifier = encodeURIComponent(identifier);
    const path = `${LEADERSHIP_PAGE_PATH_SEGMENT}/${groupKey}/${encodedIdentifier}`;
    return new URL(path, window.location.origin).toString();
};
const buildLeadershipPseudoPageTitle = (groupKey, personName) => `${getGroupLabel(groupKey)} - ${personName}`;
const trackLeadershipBiographyOpened = ({ personName, groupName, stableIdentifier, }) => {
    if (!personName || !groupName)
        return false;
    if (!isLeadershipPage())
        return false;
    if (!hasLeadForensicsConsent())
        return false;
    const groupKey = resolveLeadershipGroupKey(groupName);
    if (!groupKey)
        return false;
    const identifier = getProfileIdentifier(personName, stableIdentifier);
    if (!identifier)
        return false;
    const pseudoPageUrl = buildLeadershipPseudoPageUrl(groupKey, identifier);
    const pseudoPageTitle = buildLeadershipPseudoPageTitle(groupKey, personName);
    try {
        const trackLoad = getTrackLoad();
        trackLoad(pseudoPageUrl, pseudoPageTitle);
        return true;
    }
    catch (_a) {
        return false;
    }
};

export { buildLeadershipPseudoPageTitle, buildLeadershipPseudoPageUrl, resolveLeadershipGroupKey, trackLeadershipBiographyOpened };
